import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { CarrierSelection } from '../../../../../carrier-configuration/components/add-carrier-flow/carrierAccountData'
import { EnhancedCaasProfile } from '../../../../../common/models-carriers'
import { EditCalendar, PickupCalendar } from '../../../../models'
import CalendarEditModal from '../../../CalendarEditModal'
import ComplexSetupView from '../../../ComplexSetupView'

interface Props {
  hasComplexSetup: boolean
  saving: boolean
  pickupCalendar: PickupCalendar
  carrierAccountTypes: EnhancedCaasProfile[]
  carrierAccountData: CarrierSelection
  carrierServicesToCalendarNames: { [key: string]: string }
  onClose: () => void
  onSave: (data: EditCalendar) => void
}

export function PickupCalendarEditorModal(props: Props) {
  const { t } = useTranslation()

  const carrierProfile = props.carrierAccountTypes.find(
    a => a.key === props.carrierAccountData.carrier
  )
  const carrierName = carrierProfile ? carrierProfile.name : ''

  const complexSetup = props.hasComplexSetup ? (
    <ComplexSetupView
      carrierName={carrierName}
      carrierServices={props.carrierAccountData.carrierServices!}
    />
  ) : undefined

  return (
    <CalendarEditModal
      title={t('calendars.weekly.editPickupCalendarDialogButton')}
      saving={props.saving}
      editCalendar={{
        calendarName: props.pickupCalendar.name,
        carrierSelection: props.carrierAccountData,
      }}
      carrierServicesToCalendarNames={props.carrierServicesToCalendarNames}
      carrierAccountTypes={props.carrierAccountTypes}
      onSave={props.onSave}
      onClose={props.onClose}
      editable={true}
    >
      {complexSetup}
    </CalendarEditModal>
  )
}
